'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).controller('customerListCtrl', function ($scope, $rootScope, $state, $http, $filter, permissionService, settings, apiSettings, list, MessageService, FileSaver, Reports, Customer) {
	var vm = this;

	vm.permissions = permissionService;
	if (!vm.permissions.isAdminAccessAuthorized())
		return;

	var $translate = $filter('translate');

	angular.extend($scope.$parent.vm, {
		title: 'customers.settings.title',
		insertUrl: 'main.customer-edit'
	});

	$rootScope.laddaLoading = false;

	// Pagination
	vm.pagination = {
		list: list,
		currentPage: 1,
		pageSize: apiSettings.defaultPageSize,
		pagesTotal: list.total
	};

	$scope.$watch('vm.keyword', function (newValue, oldValue) {
		if (newValue !== oldValue) {
			vm.refresh(vm.pagination.currentPage, newValue);
		}
	});

	$scope.$watch('vm.pagination.currentPage', function (newValue, oldValue) {
		if (newValue !== oldValue) {
			vm.refresh(newValue, vm.keyword);
		}
	});

	vm.refresh = function (page, keyword) {
		Customer.list({ page: page, keyword: keyword }).$promise.then(function (data) {
			vm.pagination.list = data;
			vm.pagination.currentPage = data.page;
			vm.pagination.pagesTotal = data.total;
		});
	}

	vm.delete = function (id, index) {
		MessageService.confirmDelete(function () {
			Customer.delete({ id: id }, function () {
				vm.pagination.list.rows.splice(index, 1);
			});
		});
	}

	vm.goToImport = function () {
		$state.go('main.customer-upload');
	}

	vm.excel = function () {
		var params = { keyword: vm.keyword };

		Reports.customerExcel(params, function (response) {
			var filename = moment().format('YYYYMMDDHHmmss') + '_Clientes.xlsx';

			FileSaver.saveAs(response.data, filename);
		}, function (response) {
			var msg = $translate('errors.couldNotCompleteRequest');

			MessageService.alertError(msg);
		});
	}
});